import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';

import { AreaDiameterMeasurementBox } from './AreaDiameterMeasurementBox';
import { AreaMeasurementBox } from './AreaMeasurementBox';
import { VolumeMeasurementBox } from './VolumeMeasurementBox';
import { AngleMeasurementBox } from './AngleMeasurementBox';

import { DistanceMeasurementBox } from './DistanceMeasurementBox/DistanceMeasurementBox.tsx';
import { WideAreaMeasurementBox } from '@/components/boxes/measurementBoxes/wideAreaMeasurement/WideAreaMeasurementBox.tsx';
import { VariableDistanceMeasurementBox } from '@/surgeries/cardiac/TTVR/components/boxes/measurementBoxes/VariableDistanceMeasurementBox/BoxComponent/VariableDistanceMeasurementBox.tsx';
import { FlagMeasurementBox } from '@/components/boxes/measurementBoxes/FlagMeasurementBox/FlagMeasurementBox.tsx';
import { ValueMeasurementBox } from '@/components/boxes/measurementBoxes/ValueMeasurementBox/ValueMeasurementBox.tsx';

import { MeasurementKind } from '@/engine/app/interfaces';
import { TYPES } from '@/engine/ioc';

import type { FC } from 'react';
import type {
  MeasurementBoxesController,
  MeasurementBoxProps
} from './MeasurementBoxesController/MeasurementBoxes.controller.ts';
import type { IPlanningEntityProps } from '@/components/common/interfaces.ts';

export const MeasurementBoxes: FC<IPlanningEntityProps<MeasurementBoxProps>> = observer(({ entity }) => {
  const controller: MeasurementBoxesController = useInjection<MeasurementBoxesController>(
    TYPES.IMeasurementsBoxesController
  );

  return (
    <>
      {entity.kind === MeasurementKind.WideArea && (
        <WideAreaMeasurementBox key={'warmbox' + entity.order} measurements={entity.measurements} />
      )}
      {entity.kind === MeasurementKind.Area && (
        <AreaMeasurementBox key={'armbox' + entity.order} measurements={entity.measurements} />
      )}
      {entity.kind === MeasurementKind.AreaDiameter && (
        <AreaDiameterMeasurementBox key={'ardmdbox' + entity.order} measurements={entity.measurements} />
      )}
      {entity.kind === MeasurementKind.VariableDistance && (
        <VariableDistanceMeasurementBox key={'vdmbox' + entity.order} group={entity.group} measurements={entity.measurements} />
      )}
      {entity.kind === MeasurementKind.Distance && (
        <DistanceMeasurementBox
          key={'dmbox' + entity.order}
          measurements={entity.measurements}
          hasCriteria={entity.hasCriteria}
        />
      )}
      {entity.kind === MeasurementKind.Angle && (
        <AngleMeasurementBox key={'anmbox' + entity.order} measurements={entity.measurements} />
      )}
      {entity.kind === MeasurementKind.Volume && (
        <VolumeMeasurementBox
          key={'vombox' + entity.order}
          measurements={entity.measurements}
          onChangeHighlighting={(descriptor: string, highlighted: boolean): void =>
            controller.setObjectHighlighting(descriptor, highlighted)
          }
        />
      )}
      {entity.kind === MeasurementKind.Value && (
        <ValueMeasurementBox
          key={'vambox' + entity.order}
          measurements={entity.measurements}
          hasCriteria={entity.hasCriteria}
        />
      )}
      {entity.kind === MeasurementKind.Flag && (
        <FlagMeasurementBox
          key={'fmbox' + entity.order}
          measurements={entity.measurements}
          hasCriteria={entity.hasCriteria}
        />
      )}
    </>
  );
});
